import { TimeOptionType } from 'src/features/trends/types';
import { differenceInDays, differenceInHours } from 'date-fns';

export const getAggregationType = (
  start: Date,
  end: Date,
  selectedBox: TimeOptionType
): 'two_hour' | 'five_min' | 'thirty_min' | null => {
  const difference = differenceInDays(end, start);
  const hourDifference = differenceInHours(end, start);
  const now = new Date();
  const olderThanSevenDays = differenceInDays(now, start) > 7;

  if (hourDifference < 24) {
    return null;
  }

  if (olderThanSevenDays && difference < 3) {
    return 'five_min';
  } else if (selectedBox === '1d' || difference < 3) {
    return null;
  } else if (difference < 7 || selectedBox === '7d') {
    return 'five_min';
  } else {
    return 'two_hour';
  }
};
